import React from 'react';
import { FeatureFlag, useFeatureFlags } from '../contexts/FeatureFlagsContext';
import BillingModuleUnavailable from './BillingModuleUnavailable';

type Props = {
  children: React.ReactNode;
};

/**
 * Kill-switch facturation backoffice (BILLING_MODULE).
 * Flag off → message de travaux (la nav reste visible via billingUi pays).
 */
export const RequireBillingModule: React.FC<Props> = ({ children }) => {
  const { isFeatureEnabled } = useFeatureFlags();
  const billingEnabled = isFeatureEnabled(FeatureFlag.BILLING_MODULE);

  if (!billingEnabled) {
    return <BillingModuleUnavailable />;
  }

  return <>{children}</>;
};

export default RequireBillingModule;
